const OneOnOneMentorCall = ({ language, isSavedUser }) => {
  return {
    title: "One-on-One Mentor Call",
    subtitle:
      "Book a personal consultation with experienced sellers and coaches who've made 7-figure profits on Amazon",
    href: "https://learn.amzscout.net/pricing-yearly-mentor-call?r=menu",
  };
};

export default OneOnOneMentorCall;
